/**
 * protected-route.js
 *
 * Wraps a route element with tier-based access control.
 *   - Not signed in  → /login
 *   - Wrong tier     → /pricing?upgrade=<requiredTier> (pricing-page.js shows a
 *                      different notice if requiredTier isn't currently sold —
 *                      see PRICING_PAGE_PLAN_KEYS there)
 *   - Access OK      → renders element
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/auth-context';
import { hasAccess } from '../config/tier-config';

function ProtectedRoute({ element, requiredTier = 'free' }) {
  const { user, tier, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60vh', color: 'rgba(255,255,255,0.6)' }}>
        Loading…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!hasAccess(tier, requiredTier)) {
    return <Navigate to={'/pricing?upgrade=' + requiredTier} replace />;
  }

  return element;
}

export default ProtectedRoute;
